import React, { forwardRef, SVGProps } from 'react';
import styled from 'styled-components';
import WavePath, { waves } from './WavePath';
import useIsMobile from '@client/core/CustomHooks/useIsMobile';

const StyledSvg = styled.svg<{ $flip?: boolean }>`
	display: block;
	height: var(--breaker-height);
	width: 100%;
	position: relative;
	z-index: 1;

	${props =>
		props.$flip
			? `
		padding-bottom: var(--breaker-padding);
		margin-bottom: calc(var(--breaker-total) * -1);
		margin-top: -1.5px;
		`
			: `
		padding-top: var(--breaker-padding);
		margin-top: calc(var(--breaker-total) * -1);
		margin-bottom: -1.5px;
		`}
`;

type WaveDividerProps = {
	bg?: string;
	fg?: string;
	flip?: boolean;
	index?: number;
} & SVGProps<SVGSVGElement>;

export default forwardRef<SVGSVGElement, WaveDividerProps>(function WaveDivider(
	{ bg, fg, flip, index, ...props },
	ref
) {
	const isMobile = useIsMobile();

	return (
		<StyledSvg
			className='BreakerModule'
			ref={ref}
			viewBox={isMobile ? waves.mobile.viewbox : waves.desktop.viewbox}
			$flip={flip}
			{...props}
		>
			{bg && <rect x='0' y='0' width='1' height='1' fill={bg} />}
			<WavePath fill={fg} flip={flip} index={index} />
		</StyledSvg>
	);
});
